/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_OutbuildingInputs */

const cs_enum_outbuilding = /** @type {(inputs: Enum_OutbuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hospodářská budova`)
};

const en_enum_outbuilding = /** @type {(inputs: Enum_OutbuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outbuilding`)
};

/**
* | output |
* | --- |
* | "Outbuilding" |
*
* @param {Enum_OutbuildingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_outbuilding = /** @type {((inputs?: Enum_OutbuildingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_OutbuildingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_outbuilding(inputs)
	return cs_enum_outbuilding(inputs)
});